export default __webpack_public_path__ + "static/media/workshop_03.651d60d7.jpg";